import { Box, FlexColumn, OverflowText } from "designSystem/index";
import DojoView from "csi/page/DojoView";
import { observer } from "mobx-react-lite";
import React from "react";
import { useMassUpdateStyleSizeChartStore } from "./MassUpdateStyleSizeChartStore";

export const ShapeStyleSizeChartsTable = observer(() => {
	const store = useMassUpdateStyleSizeChartStore();
	const { viewParams, revisionParentUrl } = store;

	return (
		<FlexColumn p={5}>
			<Box mb={1.5}>
				<OverflowText res="MassUpdateStylesSizeChart_SubTitle1" />
			</Box>
			<Box growNoOverflow>
				<DojoView 
					fullHeight 
					nodeUrl={revisionParentUrl} 
					viewId="StyleSizeChartsGroupByParent" 
					viewNodeType="SizeChart" 
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});